export const initialState = {
    filter: {
      code: null,
      criteria: null,
      status: null,
      page: null,
      size: null
    },
    isFilter: false,
    typeAction: null
  };
  
  const searchCriteriaReducer = (state = initialState, action) => {
    switch (action.type) {
      case "SET_FILTER_CRITERIA":
        return {
          ...state,
          filter: action.filter,
          isFilter: action.isFilter,
          typeAction: action.typeAction,
        };
      default:
        return state;
    }
  };
  
  export default searchCriteriaReducer;
  